import { Spinner } from '@cint/wonderment';
import { Box, LssProp } from '@lucidhq/lucidium';
import React from 'react';

import useHasPermission from '@/hooks/useHasPermission';

import { UnauthorizedMessage } from '../UnauthorizedMessage';

interface ProtectedProps {
  action: string;
  resource: string;
  children: React.ReactNode;
  showFallbackUI?: boolean;
  lss?: LssProp;
  isAllCompaniesRequired?: boolean;
}

export const Protected = ({
  action,
  resource,
  children,
  showFallbackUI = true,
  lss,
  isAllCompaniesRequired,
}: ProtectedProps) => {
  const { hasPermission, isLoading } = useHasPermission({
    action,
    resource,
    isAllCompaniesRequired,
  });

  if (isLoading) {
    return <Spinner />;
  }

  if (!hasPermission && showFallbackUI) {
    return (
      <Box lss={lss}>
        <UnauthorizedMessage />
      </Box>
    );
  }

  if (!hasPermission) {
    return null;
  }

  return <>{children}</>;
};

export default Protected;
